<div class="gl-page oje-page">
  <div class="gl-page__header">
    <h1 class="gl-page__title">Overzicht journaalpost</h1>
  </div>

  <yds-card>
    <h2 header>Details</h2>

    <form class="oje-form">
      <p class="gl-form__required-hint">
        Velden gemarkeerd met een sterretje
        <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> zijn verplicht.
      </p>

      <div class="oje-field">
        <label class="oje-field__label">
          Bedrijf
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>
        </label>
        <div class="oje-field__control">
          <yds-dropdown
            [items]="institutionOptions()"
            [value]="institutionId()"
            [placeholder]="'Selecteer een bedrijf'"
            (valueChange)="onInstitutionChange($event)"
          />
        </div>
      </div>

      <div class="oje-field">
        <label class="oje-field__label">Soort berekening</label>
        <div class="oje-field__control">
          <span class="oje-field__text">Salarisberekening</span>
        </div>
      </div>

      <div class="oje-field">
        <label class="oje-field__label">
          Boekingsgroep
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>
        </label>
        <div class="oje-field__control">
          <yds-dropdown
            [items]="bookingGroupOptions()"
            [value]="bookingGroupId()"
            [required]="true"
            [disabled]="!hasInstitution()"
            [placeholder]="'Selecteer een boekingsgroep'"
            (valueChange)="onBookingGroupChange($event)"
          />
        </div>
      </div>

      <div class="oje-field">
        <label class="oje-field__label">
          Overzichtdefinitie
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>
        </label>
        <div class="oje-field__control">
          <yds-dropdown
            [items]="overviewDefinitionOptions()"
            [value]="overviewDefinitionId()"
            [required]="true"
            [disabled]="!hasInstitution() || !hasBookingGroup()"
            [placeholder]="'Selecteer een overzichtdefinitie'"
            (valueChange)="onOverviewDefinitionChange($event)"
          />
        </div>
      </div>

      <div class="oje-field">
        <label class="oje-field__label">
          Consolidatiedefinitie
        </label>
        <div class="oje-field__control">
          <yds-dropdown
            [items]="consolidationDefinitionOptions()"
            [value]="consolidationDefinitionId()"
            [disabled]="!hasInstitution() || !hasBookingGroup()"
            [placeholder]="'Selecteer een consolidatiedefinitie'"
            (valueChange)="onConsolidationDefinitionChange($event)"
          />
        </div>
      </div>

      @if (isLoadingDefinitions()) {
        <div class="oje-loading-definitions">
          <yds-spinner [label]="'Definities laden...'" />
        </div>
      }
    </form>

    @if (isLoadingResults()) {
      <div class="gl-list-state">
        <yds-spinner [label]="'Journaalposten laden...'" />
      </div>
    } @else if (hasSearched()) {
      @if (tableItems().length === 0) {
        <yds-empty-states [message]="'Er zijn geen journaalposten gevonden'" />
      } @else {
        <div class="oje-results">
          <yds-table
            class="oje-table"
            [embedded]="true"
            [interactive]="true"
            [clickable]="true"
            [columns]="tableColumns"
            [items]="tableItems()"
            [rowKey]="'id'"
            [zebra]="false"
            [(selectedIds)]="selectedIds"
            (rowClick)="onTableRowClick($event)"
          >
            <ng-template ydsTableCell="payrollProcessingType">
              Vervolg verwerking met afsluiting
            </ng-template>
            <ng-template ydsTableCell="journalingType"> Vervanging </ng-template>
          </yds-table>

          <div class="oje-results__actions">
            <yds-button
              variant="primary"
              [disabled]="!hasSelectedRows() || isCreatingJournalFile()"
              (click)="createJournalFile()"
            >
              <span class="oje-create-button__content">
                @if (isCreatingJournalFile()) {
                  <yds-spinner
                    class="oje-create-button__spinner"
                    size="sm"
                    [label]="'Journaalbestand maken...'"
                  />
                  <span>Bezig met maken...</span>
                } @else {
                  <span>Maak journaalbestand</span>
                }
              </span>
            </yds-button>
          </div>
        </div>
      }
    }
  </yds-card>
</div>
